import { CookieUtil } from '@axiom/ui';
import type { Location } from 'react-router';

import { UsersApi } from '../api/users-api';

import { EnvUtil } from './env-util';

export const LoginFlowUtil = {
  parseRelayState: ({
    location,
    appUrl = '',
    query,
  }: {
    appUrl?: string;
    location: Location;
    query: URLSearchParams;
  }) => {
    const relayState = query.get('RelayState');
    let relayTo = appUrl;

    if (relayState) {
      // add http protocol and hash, if needed and if possible, to relayState
      let protocol = '';
      let hash = '';

      if (!relayState.includes('http')) {
        // test-url.com => http(s)://test-url.com
        protocol = `${window.location.protocol}//`;
      }

      if (location.hash && !relayState.includes('#')) {
        // test-url.com => test-url.com#potato
        hash = location.hash;
      }

      relayTo = `${protocol}${relayState}${hash}`;
    }

    return relayTo;
  },
  getTOSUrl({
    location,

    query,
  }: {
    location: Location;
    query: URLSearchParams;
  }) {
    const relayUrl = LoginFlowUtil.parseRelayState({
      appUrl: '',
      query,
      location,
    });
    return {
      url: `/terms-of-use${relayUrl.length > 0 ? `?RelayState=${relayUrl}` : ''}`,
      replace: false,
    };
  },
  getRedirectUrl: async ({
    location,
  }: {
    location: Location;
  }): Promise<{ url?: string; replace: boolean }> => {
    const query = new URLSearchParams(location.search);
    // We need to make sure we're pulling the most up-to-date user
    UsersApi.clearUser();
    const { data: user } = await UsersApi.readCurrentUser().toPromise();

    const userToken = query.get('user') ?? CookieUtil.getUserToken();

    if (!CookieUtil.isUserExpired(userToken ?? '')) {
      return {
        url: '/',
        replace: true,
      };
    }

    if (user.roles.some(r => r.includes('ClientUser'))) {
      if (user.hasAcceptedTermsAndConditions) {
        return {
          url: LoginFlowUtil.parseRelayState({
            appUrl: EnvUtil.afcRedirect,
            query,
            location,
          }),
          replace: false,
        };
      }

      return LoginFlowUtil.getTOSUrl({ location, query });
    } else if (user.roles.some(r => r.includes('Envoy'))) {
      return {
        url: LoginFlowUtil.parseRelayState({
          appUrl: EnvUtil.envoyRedirect,
          query,
          location,
        }),
        replace: false,
      };
    } else if (user.roles.some(r => r.includes('LPUser'))) {
      if (user.hasAcceptedTermsAndConditions) {
        return {
          url: LoginFlowUtil.parseRelayState({
            appUrl: EnvUtil.portalRedirect,
            query,
            location,
          }),
          replace: false,
        };
      }
      return LoginFlowUtil.getTOSUrl({ location, query });
    }

    return {
      replace: false,
    };
  },
};
